import { render } from "./AssignTaskRule.vue?vue&type=template&id=4dcd9f25&ts=true"
import script from "./AssignTaskRule.vue?vue&type=script&lang=ts"
export * from "./AssignTaskRule.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__